import React from "react";

const LoadAnalysis = () => {

    return (
        <div>
            Load Analysis
        </div>
    )
}

export default LoadAnalysis;